import { LogOut } from "lucide-react";
import type { AuthUser } from "../lib/api";
import { NotificationBell } from "./NotificationBell";

type Props = {
  user: AuthUser | null;
  onLogout: () => void;
};

export function Header({ user, onLogout }: Props) {
  return (
    <header className="sticky top-0 z-30 border-b border-line bg-cream/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3">
        <a href="/" className="flex items-center gap-2.5 hover:opacity-80 transition-opacity">
          <img src="/logo.png" alt="DP Connect" className="size-9" />
          <div className="leading-tight">
            <div className="text-base font-semibold tracking-tight">DP Connect</div>
            <div className="text-[11px] text-ink-muted">Agenten</div>
          </div>
        </a>

        {user && (
          <div className="flex items-center gap-3">
            <div className="hidden sm:flex flex-col text-right leading-tight">
              <span className="text-xs text-ink-muted">{user.role === "admin" ? "Admin" : "Agent"}</span>
              <span className="text-sm font-medium">{user.name}</span>
            </div>
            {user.role === "agent" && <NotificationBell />}
            <button
              onClick={onLogout}
              className="grid size-9 place-items-center rounded-xl border border-line bg-white hover:bg-cream-soft transition"
              aria-label="Abmelden"
            >
              <LogOut className="size-4" />
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
